import { ConfirmationPopUpModule } from './../../../widgets/confirmation-pop-up/confirmation-pop-up.module';
import { ActivityCreateActivityPopUpModule } from './../../forecast/activity/activity-create-activity-pop-up/activity-create-activity-pop-up.module';
import { DropdownModule } from './../../../widgets/dropdown/dropdown.component';
import { DxNumberBoxModule, DxSelectBoxModule, DxTextBoxModule, DxDateBoxModule, DxCheckBoxModule, DxValidatorModule, DxButtonModule, DxLoadPanelModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component'; 
import { ChangePasswordWidgetModule } from 'src/app/widgets/change-password/change-password.module';
 

@NgModule({
  declarations: [UserComponent],
  imports: [
    CommonModule,
		UserRoutingModule,
		DxSelectBoxModule,
		DropdownModule,
		DxTextBoxModule,
		DxSelectBoxModule,
		DxNumberBoxModule,
		DxDateBoxModule,
		DxCheckBoxModule,
		DxValidatorModule,
		DxButtonModule,
		DxLoadPanelModule,DxScrollViewModule,
		DxPopupModule,
		ActivityCreateActivityPopUpModule,
		ConfirmationPopUpModule,ChangePasswordWidgetModule
  ]
})
export class UserModule { }
